import React from 'react'
import { FlexBox, Span, ToggleSwitch, ToggleSwitchOffLabel, ToggleSwitchOnLabel } from '@vp/swan'
import { useVatContext } from '../../context/VatContext'
import { isVatEnabled } from '../../utils/vat-util'

interface VatToggleProps {
  vatPlacement: string
  locale: string
}

export const VatToggle: React.FC<VatToggleProps> = ({ vatPlacement, locale }) => {
  const { vatInclusive, toggleVatInclusively, vatToggleLabel, vatToggleInclusionText, vatToggleExclusionText } = useVatContext()
  const country = locale.split('-')[1]?.toUpperCase() || ''
  const vatEnabled = isVatEnabled(country)

  if (!vatEnabled) return null

  const labelId = `vatToggleLabel-${vatPlacement}`

  return (
    <FlexBox gap="2" alignItems="center">
      {vatToggleLabel && (
        <Span id={labelId} aria-hidden="true">
          {vatToggleLabel}
        </Span>
      )}
      <ToggleSwitch
        id={`vatToggle-${vatPlacement}`}
        activated={!!vatInclusive}
        onRequestActivatedChange={toggleVatInclusively}
        aria-labelledby={vatToggleLabel ? labelId : undefined}
      >
        <ToggleSwitchOnLabel>{vatToggleInclusionText}</ToggleSwitchOnLabel>
        <ToggleSwitchOffLabel>{vatToggleExclusionText}</ToggleSwitchOffLabel>
      </ToggleSwitch>
    </FlexBox>
  )
}
